import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { CartService } from "../services/cart.service";
import { isPlatformBrowser } from "@angular/common";
import { ScreenSizeService } from "../services/screen-size.service";
import { scrollToFirstEl } from "../helpers";

@Component({
    selector: 'gea-shop-add-to-cart-popup',
    templateUrl: './add-to-cart-popup.component.html',
    styleUrls: ['./add-to-cart-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddToCartPopupComponent {

  public cartService = inject(CartService)
  public show: boolean = false
  public hiding: boolean = false
  public mouseover: boolean = false

  private _taId: number | undefined = undefined

  @HostListener("document:click") onBodyClick() {
    if (! this.mouseover && this.show) {
      this.hide(500)
      return false
    }
    return true
  }
  @HostListener('mouseenter') onHover(){
    this.mouseover = true
    clearTimeout(this._taId)
  }
  @HostListener('mouseleave') onLeave(){
    this.mouseover = false
  }

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(ScreenSizeService) private screenSizeService: ScreenSizeService,
    private cd: ChangeDetectorRef
  ) {
    this.cartService.onAdd.subscribe(item => {
      if (isPlatformBrowser(this.platformId) && this.cartService.cart().items.length) {
        if (this.screenSizeService.currentDimensionIsLargerThan('sm')) {
          scrollToFirstEl('.root-container')
          setTimeout(() => {
            this.show = true
            this.cd.detectChanges()
            this.hide(3000)
          }, 350)
        }
      }
    })
  }

  hide(timeout: number = 500) {
    if (this._taId) window.clearTimeout(this._taId)
    const that = this
    this._taId = window.setTimeout(() => {
      that.show = false
      that.cd.detectChanges()
    }, timeout)
  }
}
